import {all, call, fork, put} from "redux-saga/effects";
import {apiClient} from 'util/Api'
import {bbStandardRequestHandler} from "../util/bbHelpers";
import {
    FETCH_INSIDER_ATTACK_DETAILS,
    FETCH_INSIDER_ATTACK_OPTIONS, FETCH_REQUESTED_ATTACKS, POST_NEW_REQUESTED_ATTACK,
} from "../constants/ActionTypes";
import {
    fetchInsiderAttackOptionsFail,
    fetchInsiderAttackOptionsSuccess,
     fetchRequestedAttackDetailsFail, fetchRequestedAttackDetailsSuccess,
    fetchRequestedAttacksFail,
    fetchRequestedAttacksSuccess,
    postNewAttackOnDemandFail,
    postNewAttackOnDemandSuccess,

} from "../actions";
import {takeLatest, takeLeading} from "@redux-saga/core/effects";

/* ***************************
   Fetching list of all TYPES OF attack on demands
   *************************** */

const getInsiderAttackOptionsRequest = async () =>
    await  apiClient.get(`/requested/v2/options`, {timeout: 25000}
    )
        .then(data => data)
        .catch(error => error);

function* getInsiderAttackOptionsGenerator({payload}) {
    /*  jfd*******************************
     *   Modify these parameters and the fail and success cases below
         ********************************** */
    const standardName = "getInsiderAttackOptions";     console.group(`${standardName} Generator...: `);
    // const {} = payload;
    const request = yield call(getInsiderAttackOptionsRequest);
    /*  ******END*******************/

    const didRequestSucceed = bbStandardRequestHandler(request, standardName, false, false);

    if (didRequestSucceed) {
        yield put(
            fetchInsiderAttackOptionsSuccess(
                request.data
            )
        );
    } else {
        yield put(fetchInsiderAttackOptionsFail(request));
    }

    console.groupEnd();
}


export function* watchLeadingGetInsiderAttackOptionsData() {
    yield takeLeading(FETCH_INSIDER_ATTACK_OPTIONS, getInsiderAttackOptionsGenerator);
}

/* ***************************
   Fetching list of all requested attacks on demand
   *************************** */

const getRequestedAttacksRequest = async (customerId ) =>
    await  apiClient.get(`/customer/${customerId}/attack/v2`, {timeout: 25000}
    )
        .then(data => data)
        .catch(error => error);

function* getRequestedAttacksGenerator({payload}) {
    /*  jfd*******************************
     *   Modify these parameters and the fail and success cases below
         ********************************** */
    const standardName = "getRequestedAttacks";     console.group(`${standardName} Generator...: `);
    const {customerId } = payload;
    const request = yield call(getRequestedAttacksRequest, customerId);
    /*  ******END*******************/

    const didRequestSucceed = bbStandardRequestHandler(request, standardName, false, false);

    if (didRequestSucceed) {
        yield put(
            fetchRequestedAttacksSuccess({
                statusRequested: request.data.requested,
                statusBreached: request.data.breaches,
                customerId: customerId
            })
        );
    } else {
        yield put(fetchRequestedAttacksFail(request));
    }

    console.groupEnd();
}


export function* watchLeadingGetRequestedAttacksData() {
    yield takeLeading(FETCH_REQUESTED_ATTACKS, getRequestedAttacksGenerator);
}

/* ***************************
   Fetching details for a single requested attack
   *************************** */

const getRequestedAttackDetailRequest = async (attackId ) =>
    await  apiClient.get(`/requested/v2/${attackId}`, {timeout: 120000}
    )
        .then(data => data)
        .catch(error => error);

function* getRequestedAttackDetailGenerator({payload}) {
    /*  jfd*******************************
     *   Modify these parameters and the fail and success cases below
         ********************************** */
    const standardName = "getRequestedAttackDetail";     console.group(`${standardName} Generator...: `);
    const {attackId, customerId } = payload;
    const request = yield call(getRequestedAttackDetailRequest, attackId);
    /*  ******END*******************/

    const didRequestSucceed = bbStandardRequestHandler(request, standardName, false, false);

    if (didRequestSucceed) {
        yield put(
            fetchRequestedAttackDetailsSuccess({
                inboundData: request.data,
                customerId: customerId,
                attackId: attackId
            })
        );
    } else {
        yield put(fetchRequestedAttackDetailsFail(request));
    }

    console.groupEnd();
}


export function* watchLatestGetRequestedAttackDetail() {
    yield takeLatest(FETCH_INSIDER_ATTACK_DETAILS, getRequestedAttackDetailGenerator);
}

/* ***************************
   POSTING a new Attack on Demand
   *************************** */

const postNewAoDRequest = async (customerId, attackPackageId) =>
    await  apiClient.post(`/requested/v2/new`,
        {
            CustomerId: customerId,
            AttackPackageId: attackPackageId,
        },{timeout: 25000}
    )
        .then(data => data)
        .catch(error => error);

function* postNewAoDGenerator({payload}) {
    /*  jfd*******************************
     *   Modify these parameters and the fail and success cases below
         ********************************** */
    const standardName = "postNewAoD";     console.group(`${standardName} Generator...: `);
    const {customerId, attackPackageId } = payload;
    const request = yield call(postNewAoDRequest, customerId, attackPackageId);
    /*  ******END*******************/

    const didRequestSucceed = bbStandardRequestHandler(request, standardName, true, false);

    if (didRequestSucceed) {
        yield put(
            postNewAttackOnDemandSuccess(
                {
                    inboundData: request.data,
                    attackPackageId: attackPackageId,
                    customerId : customerId,
                }
            )
        );
    } else {
        yield put(postNewAttackOnDemandFail({
            inboundData: request.data,
            attackPackageId: attackPackageId
        }));
    }

    console.groupEnd();
}


export function* watchLeadingPostNewAoDData() {
    yield takeLeading(POST_NEW_REQUESTED_ATTACK, postNewAoDGenerator);
}


/* ***************************
   root Saga
   *************************** */

export default function* rootSaga() {
    yield all([
        fork(watchLeadingGetInsiderAttackOptionsData),
        fork(watchLeadingPostNewAoDData),
        fork(watchLeadingGetRequestedAttacksData),
        fork(watchLatestGetRequestedAttackDetail),
    ]);
}